export default "__VITE_ASSET__CiHE6qKm__"